import { jsx as _jsx } from "react/jsx-runtime";
import Svg from '../../Svg';
const CarretIcon = ({ size, ...rest }) => {
    return (_jsx(Svg, { size: size, viewBox: "0 0 32 32", ...rest, children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26.3709 13.7237C26.8916 14.2444 26.8916 15.0886 26.3709 15.6093L16.9428 25.0374C16.4221 25.5581 15.5779 25.5581 15.0572 25.0374L5.6291 15.6093C5.1084 15.0886 5.1084 14.2444 5.6291 13.7237", fill: "currentColor" }) }));
};
export default CarretIcon;
//# sourceMappingURL=CarretIcon.js.map